var _path, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvolutionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.22266 16.8594L2.84766 15.4844L9.72266 8.60938L13.375 12.3047L19.8633 5L21.1523 6.28906L13.375 15.0547L9.72266 11.3594L4.22266 16.8594Z",
    fill: "#797D8D"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 20.9297,
    x2: -8.74228e-8,
    y2: 20.9297,
    stroke: "#00D084",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvolutionIcon);
export default __webpack_public_path__ + "static/media/evolution_icon.b236dca2d0ff8d975ec927d9881956f1.svg";
export { ForwardRef as ReactComponent };